import { render, staticRenderFns } from "./datav.vue?vue&type=template&id=40acbf50&scoped=true&"
import script from "./datav.vue?vue&type=script&lang=js&"
export * from "./datav.vue?vue&type=script&lang=js&"
import style0 from "./datav.vue?vue&type=style&index=0&id=40acbf50&prod&lang=scss&scoped=true&"
import style1 from "./datav.vue?vue&type=style&index=1&id=40acbf50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40acbf50",
  null
  
)

export default component.exports